import { waitForGtag, isApplePayCompatible } from '../../core/helpers.js';

export default class AdditionalPayments {
  elements;

  constructor() {
    this.elements = {
      stickyMobileAdditionalButtonsContainer: document.querySelector('[data-cart-sticky-additional-checkout-buttons] .cart-sticky-buttons-mobile__additional-payments-custom'),
      stickyMobileInstallmentsContainer: document.querySelector('[data-cart-sticky-additional-checkout-buttons] .cart-sticky-buttons-mobile__installments'),
      desktopAdditionalButtonsContainer: document.querySelector('[data-cart-summary="desktop"] .cart-summary__additional-payments-custom'),
      desktopInstallmentsContainer: document.querySelector('[data-cart-summary="desktop"] .cart-summary__installments'),
    };

    // Google Analytics events
    document.addEventListener('click', (e) => {
      const checkoutBtn = e.target.closest('.cart-sticky-buttons-mobile__main');
      if (checkoutBtn) {
        e.preventDefault();
        waitForGtag(() => {
          gtag('event', `cart_guest_checkout_main_${(window.theme.breakpoints.current === 'mobile') ? 'mobile' : 'desktop'}`);
        });

        setTimeout(() => {
          window.location = checkoutBtn.getAttribute('href');
        }, 150);
      }

      const googlePayBtn = e.target.closest('[data-cart-sticky-buttons-mobile] shopify-google-pay-button');
      if (googlePayBtn) {
        e.preventDefault();
        waitForGtag(() => {
          gtag('event', `cart_add_to_bag_google_${(window.theme.breakpoints.current === 'mobile') ? 'mobile' : 'desktop'}`);
        });
        return;
      }

      const applePayBtn = e.target.closest('[data-cart-sticky-buttons-mobile] shopify-apple-pay-button');
      if (applePayBtn) {
        e.preventDefault();
        waitForGtag(() => {
          gtag('event', `cart_add_to_bag_apple_${(window.theme.breakpoints.current === 'mobile') ? 'mobile' : 'desktop'}`);
        });
        return;
      }

      const installmentsBtn = e.target.closest('[data-cart-sticky-buttons-mobile] shop-pay-wallet-button');
      if (installmentsBtn) {
        e.preventDefault();
        waitForGtag(() => {
          gtag('event', `cart_add_to_bag_shoppay_${(window.theme.breakpoints.current === 'mobile') ? 'mobile' : 'desktop'}`);
        });
        return;
      }
    });

    this.updateAdditionalCheckoutButtons();
    window.addEventListener('resize', this.handleResize);
  };

  handleResize = () => {
    const targetContainer = window.theme.breakpoints.current !== 'mobile' ? this.elements.desktopAdditionalButtonsContainer : this.elements.stickyMobileAdditionalButtonsContainer;

    if (!targetContainer) return;

    if (this.elements.applePayButton && !targetContainer.contains(this.elements.applePayButton)) {
      targetContainer.appendChild(this.elements.applePayButton);
    }
    
    if (this.elements.googlePayButton && !targetContainer.contains(this.elements.googlePayButton)) {
      targetContainer.appendChild(this.elements.googlePayButton);
    }

    if (this.elements.shopPayButton && !targetContainer.contains(this.elements.shopPayButton)) {
      // Ensure Shop Pay is always first or last depending on design? 
      // Original code prepended it.
      targetContainer.prepend(this.elements.shopPayButton);
    }
  };

  addShopPayButton = () => {
    let attemptsShopPay = 0;
    const interval = window.setInterval(() => {
      const shopPayElement = document.querySelector('[data-cart-sticky-buttons-mobile] shop-pay-wallet-button');
      
      if (shopPayElement) {
        window.clearInterval(interval);
        this.elements.shopPayButton = shopPayElement;
        
        this.handleResize(); // Move to correct container

        if (this.elements.stickyMobileInstallmentsContainer) {
          this.elements.stickyMobileInstallmentsContainer.classList.add('active');
        }

        if (this.elements.desktopInstallmentsContainer) {
          this.elements.desktopInstallmentsContainer.classList.add('active');
        }
        
        return 'shop-pay';
      }

      if (!shopPayElement) {
        attemptsShopPay++;
      }

      if (attemptsShopPay >= 5) {
        window.clearInterval(interval);
        console.log('Shop Pay button not found');
        return 'none';
      }
    }, 500);
  };

  /**
   * Adds either Apple Pay or Google Pay button then Shop Pay button
   * 
   * @returns {'apple' | 'google' | 'none'}
   */
  updateAdditionalCheckoutButtons = () => {
    if (!this.elements.stickyMobileAdditionalButtonsContainer) return 'none';

    let attemptsApplePay = 0;
    let attemptsGooglePay = 0;
    const interval = window.setInterval(() => {
      const applePayElement = document.querySelector('[data-cart-sticky-buttons-mobile] shopify-apple-pay-button');
      
      if (applePayElement) {
        window.clearInterval(interval);
        this.elements.applePayButton = applePayElement;
        this.handleResize();
        this.addShopPayButton();
        return 'apple';
      }

      if (!applePayElement) {
        attemptsApplePay++;
      }

      if (attemptsApplePay >= 5) {
        window.clearInterval(interval);
        console.log('Apple Pay button not found');

        const intervalGooglePay = window.setInterval(() => {
          // Default to Google Pay if Apple Pay not found
          const googlePayElement = document.querySelector('[data-cart-sticky-buttons-mobile] shopify-google-pay-button');

          if (googlePayElement) {
            window.clearInterval(intervalGooglePay);
            this.elements.googlePayButton = googlePayElement;
            this.handleResize();
            this.addShopPayButton();
            return 'google';
          }

          if (!googlePayElement) {
            attemptsGooglePay++;
          }

          if (attemptsGooglePay >= 5) {
            window.clearInterval(intervalGooglePay);
            console.log('Google Pay button not found');
            this.addShopPayButton();
            return 'none';
          }
        }, 500);
      }
    }, isApplePayCompatible ? 500 : 1);
  };
}
